import config from './config.js'

export default {

  loadinfo: function(ctrl,cb_success) {
    config.get(ctrl, config.baseUrl + 'rest/jobs/info?group=DEF&name=all','Sync-Status laden',cb_success);
  },

  resettimestamps: function(ctrl,cb_success) {
    config.get(ctrl, config.baseUrl + 'rest/jobs/resettime','Zeitstempel zurück setzen',cb_success)
  },

  startsync: function(ctrl,actions,cb_success) {
    var url = config.baseUrl + 'rest/jobs/control?target=none&action=';

    for (var i=0;i<actions.length;i++) {
      var e = actions[i];
      url += ';' + e;
    }
    console.log(url);

    config.get(ctrl,url,'Synchronisation starten',cb_success);
  }

}
